module.exports = window["__sharedAtgHistory"];